















































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import authModel from "@/models/auth.model";
import EntityField from "@/layouts/components/EntityField.vue";
import Logo from '../../layouts/components/Logo.vue'

@Component({ components: {
  EntityField,
  Logo
}})
export default class PasswordRecovery extends Vue {

  email = "";
  sendCode = false;

  errorEmail = false;
  errorLength = false;
  errorCode = false

  passwordResetCode = ""
  newPassword = ""
  newPasswordConfirm = ""

  changePasswordPage() {
    this.sendCode = true
  }

  async sendRecoveryCode() {
    this.$vs.loading();
    try {
      await authModel.requestPasswordReset(this.email)
      this.$vs.notify({ title: "Sucesso", text: "Código Enviado", iconPack: "feather", icon: "icon-check", color: "success" });
      this.sendCode = true;
    } catch (error) {
      this.errorEmail = true;
      this.$vs.notify({ title: "Erro", text: error.friendlyMessage || "O e-mail informado não está cadastrado", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
      console.error(error);
      }
    this.$vs.loading.close();
  }

  async updatePassword() {
    this.$vs.loading();
    this.errorLength = false;
    this.errorCode = false;

    if (this.passwordResetCode.length === 0) {
      this.errorCode = true
    }

    if (this.newPassword.length < 8 || this.newPasswordConfirm.length < 8) {
      this.errorLength = true;
    } else {
      if (this.newPassword === this.newPasswordConfirm) {
      try {
        await authModel.resetPassword(this.passwordResetCode, this.newPassword)
        this.$vs.notify({ title: "Sucesso", text: "Senha Atualizada!", iconPack: "feather", icon: "icon-check", color: "success" });
        this.sendCode = true;
        this.$router.replace("/pages/login");
      } catch (error) {
        this.$vs.notify({ title: "Erro", text: error.friendlyMessage || "Não foi possível atualizar a senha. Tente novamente.", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
        console.error('ERROR', error);
      }
      this.$vs.loading.close()
      } else {
        this.$vs.notify({ title: "Erro", text: "As senhas precisam estar iguais", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
        setTimeout(() => {
            this.$vs.loading.close()
        }, 1000);
      }
    }
    setTimeout(() => {
            this.$vs.loading.close()
    }, 1000);
  }

}

